import { campoDeveSerMaiorQueZero, campoObrigatorio } from 'helpers/Constantes/Mensagens'
import { TipoProjetoEnum } from './Enum/TipoProjetoEnum'
import { ModeloNegocioEnum } from './Enum/ModeloNegocioEnum'

export type DadosDespesasAcessorias = {
  itbiTerreno: string
  escrituras: string
  realIntencionado: string
  corretagemProspeccao: string
  valido: boolean
}

export const dadosDespesasAcessoriasValorDefault = {
  itbiTerreno: '',
  escrituras: '',
  realIntencionado: '',
  corretagemProspeccao: ''
} as DadosDespesasAcessorias

export class ValidacaoDadosDespesasAcessorias {
  itbiTerreno: string
  escrituras: string
  realIntencionado: string
  corretagemProspeccao: string

  constructor(itbiTerreno = '', escrituras = '', realIntencionado = '', corretagemProspeccao = '') {
    this.itbiTerreno = itbiTerreno
    this.escrituras = escrituras
    this.realIntencionado = realIntencionado
    this.corretagemProspeccao = corretagemProspeccao
  }

  validarValorDiferenteZero(valor: string) {
    if (parseFloat(valor) === 0) {
      return campoDeveSerMaiorQueZero
    }

    return ''
  }

  validarCampoPreenchidoValorDiferenteZero(valor: string, tipoProjeto: string, modeloNegocio: string) {
    if ((tipoProjeto === TipoProjetoEnum.CondominioIncorporacao || modeloNegocio === ModeloNegocioEnum.MrvAdquirenteLote) && (!valor || valor === '')) {
      return campoObrigatorio
    }

    if (parseFloat(valor) === 0) {
      return campoDeveSerMaiorQueZero
    }

    return ''
  }

  validarTodosCampos(state: DadosDespesasAcessorias): boolean {
    if (
      state.itbiTerreno != '' &&
      this.itbiTerreno === '' &&
      state.escrituras != '' &&
      this.escrituras === '' &&
      this.realIntencionado === '' &&
      this.corretagemProspeccao === ''
    ) {
      return true
    }
    return false
  }
}
